import { ORDER_MEDICINES_CART } from './constants';
import { ExtraCharges, FareDict } from './fetchMedicinesByPrescriptionId';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    id: string;
    amount: number;
    paidAmount: number;
    platformdiscount: number;
    order: Order;
    error?: string;
}
export interface Order {
    id: string;
    status: string;
    pxid: string;
    pxurl: string;
    docid: string;
    patientid: string;
    vendorid: string;
    vendorname: string;
    customerDetails: CustomerDetails;
    created_at: string;
    updated_at: string;
    vendor_order_id: string;
    amount: number;
    paidAmount: number;
    totalMRP: number;
    absoluteDiscount: number;
    discountedPrice: number;
    totalAmount: number;
    platformdiscount: number;
    pincode: string;
    address: Address;
    cart?: CartEntity[] | null;
    requestedCart?: CartEntity[] | null;
    paymode: string;
    extra_charges?: ExtraCharges;
    eta?: string;
    eta_display?: string;
}
export interface CustomerDetails {
    age: number;
    name: string;
    email?: string;
    gender: string;
    mobile: string;
    customer_email?: string;
    alternative_mobile: string;
}
export interface Address {
    city: string;
    line: string;
    state: string;
    city_id: string;
    pincode: string;
    landmark: string;
    coordinates: string;
}
export interface CartEntity {
    qty: number;
    name: string;
    image: string;
    price: number;
    eka_id: string;
    discount: number;
    vendor_id: string;
    product_sku: string;
    totalamount: number;
    generic_name: string;
    product_type: string;
    manufacturer_name: string;
    isInvalidPrice?: boolean;
}

export interface Request {
    docid: string;
    patientid: string;
    pxid: string;
    address: Address;
    cart?: CartEntity[] | null;
    discount: number;
    customerDetails: CustomerDetails;
    pincode: string;
    vendor: string;
    vendor_error: string;
    paymode: string;
    placedByDoctor?: boolean;
    extra_charges?: ExtraCharges;
    eta?: string;
    eta_display?: string;
    fareDict?: FareDict;
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(ORDER_MEDICINES_CART(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
